// mobile + landline
export const phoneRegex = /^(0)(-)?0?(([23489]{1}-?\d{7})|[5]{1}\d{1}-?\d{7})$/;

// mobile only
export const mobilePhoneRegex = /^(0(5(?!1)[0-9])[1-9]\d{6})$/;